import React from "react";

import { classNames } from "@assets/helperFunctions";
import { Card, Spinner, Typography } from "@samskip/frontend-components";

type RequestCardProps = {
  label: string;
  loading: boolean;
  value: string;
  isSelected: boolean;
  handleCardsFilterStatusChange: () => void;
};

const RequestCard = ({
  label,
  loading,
  value,
  isSelected,
  handleCardsFilterStatusChange,
}: RequestCardProps) => {
  return (
    <Card
      bordered={isSelected}
      className={classNames(
        "cursor-pointer transition-all bg-neutral-100",
        isSelected && "border-primary-500"
      )}
      id={label}
      onClick={handleCardsFilterStatusChange}
    >
      <Typography color="neutral-700" fontWeight="semibold">
        {label}
      </Typography>
      {loading ? (
        <Spinner />
      ) : (
        <Typography color="neutral-900" fontWeight="semibold">
          {value}
        </Typography>
      )}
    </Card>
  );
};

export default RequestCard;
